module.exports = __webpack_public_path__ + "img/appAsset-brand--facturapi.be41385f.svg";